import { css } from '@emotion/react';

import { mqMin } from '../breakpoints';
import { LucidTheme } from '../theme';

const blogStyles = (theme: LucidTheme) => css({
  strong: {
    fontWeight: theme.fontWeights.stronger
  },
  '> ul, > ol': {
    margin: theme.space[4],
    li: {
      fontSize: theme.fontSizes[4],
      marginBottom: theme.space[2]
    }
  },
  iframe: {
    margin: `${theme.space[6]}px 0`,
    width: '100%',
    '&[src*="embeddedchart"]': {
      minHeight: '320px',
      [mqMin.tabletSmall]: {
        minHeight: '480px'
      }
    }
  }
});

export default blogStyles;
